// Static kitchen pricing removed — pricing comes from WooCommerce product meta.

export const cabinetTextureGroups = {};
export const countertopTiers = {};
export const designPricing = {};
